import FormWizardSample from "@/components/bid/StepProgress";
import BidHeader from "./BidHeader";
import BidFooter from "./BidFooter";
import MetaComponent from "../common/MetaComponent";
const metadata = {
  title: "Hubzu | Bid Wizard",
};
const BidWizard = () => {
  return (
    <>
      <MetaComponent meta={metadata} />

      {/* header */}
      {/* <Header /> */}
      <BidHeader />
      {/* <MobileMenu /> */}
      {/* <PopupSignInUp /> */}
      <FormWizardSample />

      {/* footer */}
      <section className="p-0">
        <div className="">
          <div className="">
            {/* <Footer /> */}
            <BidFooter />
          </div>
        </div>
      </section>
    </>
  );
};

export default BidWizard;
